/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface PatchDocument
 */
export interface PatchDocument  {
    /**
     * 
     * @type {PatchDocumentOpEnum}
     * @memberof PatchDocument
     */
    op?: PatchDocumentOpEnum;
    /**
     * 
     * @type {string}
     * @memberof PatchDocument
     */
    path?: string;
    /**
     * 
     * @type {any}
     * @memberof PatchDocument
     */
    value?: any | null;
    /**
     * 
     * @type {string}
     * @memberof PatchDocument
     */
    from?: string;
}


/**
 * @export
 */
export const PatchDocumentOpEnum = {
    Add: 'add',
    Remove: 'remove',
    Replace: 'replace',
    Move: 'move',
    Copy: 'copy',
    Test: 'test'
} as const;
export type PatchDocumentOpEnum = typeof PatchDocumentOpEnum[keyof typeof PatchDocumentOpEnum];


/**
 * Check if a given object implements the PatchDocument interface.
 */
export function instanceOfPatchDocument(value: object): value is PatchDocument {
    return true;
}

export function PatchDocumentFromJSON(json: any): PatchDocument {
    return PatchDocumentFromJSONTyped(json, false);
}

export function PatchDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchDocument {
    if (json == null) {
        return json;
    }
    return {
        
                  'op': json['op'] == null ? undefined : json['op'],
                  'path': json['path'] == null ? undefined : json['path'],
                  'value': json['value'] == null ? undefined : json['value'],
                  'from': json['from'] == null ? undefined : json['from'],
    };
}

export function PatchDocumentToJSON(json: any): PatchDocument {
    return PatchDocumentToJSONTyped(json, false);
}

export function PatchDocumentToJSONTyped(value?: PatchDocument | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'op': value['op'],
        'path': value['path'],
        'value': value['value'],
        'from': value['from'],
    };
}


